import React, { useEffect } from 'react';

import { SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import Input from 'components/lib/Input';
import { useDebounce } from 'utils/hooks/useDebounce';

import GroupsFiltersMenu from './GroupsFiltersMenu';
import { useGroupsContext } from '../GroupsContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const GroupsFilters = () => {
  const { filters, setFilters } = useGroupsContext();
  const [search, setSearch] = React.useState('');

  const debouncedSearch = useDebounce(search, 300);

  const handleChange = (event: any) => {
    setSearch(event.target.value);
  };

  useEffect(() => {
    setFilters({ ...filters, page: 1, search: debouncedSearch });
  }, [debouncedSearch]);

  const searchPlaceholder = 'Search groups by name, communities, users...';

  return (
    <Container>
      <Input
        value={search}
        prefix={<SearchOutlined />}
        style={{ width: 500 }}
        onChange={handleChange}
        placeholder={searchPlaceholder}
      />
      <GroupsFiltersMenu />
    </Container>
  );
};

export default GroupsFilters;
